import { render, staticRenderFns } from "./NavbarSubmenuItem.vue?vue&type=template&id=6dfd5925&"
import script from "./NavbarSubmenuItem.vue?vue&type=script&lang=js&"
export * from "./NavbarSubmenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports